import docPackages from './dutyOfCare';

export const packagesReducers = {
  docPackages,
};
